'use strict';

class ErrorPage {
  constructor($location, $window) {
    this.$location = $location;
    this.$window = $window;
  }

  $onInit() {
    this.statusCode = this.$location.search().status;
    this.originatorId = this.$window.sessionStorage.getItem('originatorId');
    this.error = {};

    if (this.statusCode === '404') {
      this.$window.sessionStorage.removeItem('systemError');
    }

    if (this.$window.sessionStorage.getItem('systemError')) {
      let err = angular.fromJson(this.$window.sessionStorage.getItem('systemError'));

      this.error = {
        type: 'error',
        title: err.endUserMessage,
        message: err.errors[0].endUserMessage
      };
    }
  }
}

ErrorPage.$inject = ['$location', '$window'];

const errorPage = {
  controller: ErrorPage,
  template: `
    <h2 ng-if="$ctrl.error.title">{{ $ctrl.error.title }}</h2>

    <alert data="$ctrl.error" />

    <p ng-if="$ctrl.error.message">
      For mer informasjon, vennligst ta kontakt <a href="mailto:hjelp@sendregning.no">hjelp@sendregning.no</a>
      <span ng-if="$ctrl.originatorId"> og oppgi ditt kundenummer <b>{{ $ctrl.originatorId }}</b></span>.
    </p>

    <div ng-if="!$ctrl.error.message">
      <h2>Beklager, vi kan dessverre ikke finne denne siden.</h2>
      <h3 class="subheader">Hva er galt?</h3>
      <ul class="indent-list">
        <li>Siden eksisterer ikke lenger</li>
        <li>Siden har flyttet</li>
        <li>Feilstavet nettadresse</li>
      </ul>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('errorPage', errorPage)
  .config(($routeProvider) => {
    $routeProvider
      .when('/feil', {
        title: 'Feil',
        template: '<error-page />',
        noSidebar: true,
        noNav: true,
        secure: true
      });
  });
